import React from "react";
import LaddaButton, { EXPAND_RIGHT, S } from "react-ladda";
import { browserHistory } from "react-router";
import { Button, Card, CardBlock, FormGroup, Input, Label } from "reactstrap";

import AlertMessageClass from "../../shared/components/alert_message";
import StateListClass from "../../shared/components/state_list";
import "./style.css";

import LoaderClass from "../../shared/components/loader";
import { getRequest, postRequest } from "../../utils/apiUtils";
import QuestionTableClass from "./question_table";
// import Editable,{CustomComponent} from 'react-x-editable';

//import {Table, Th, Thead} from 'reactable';
var axios = require("axios");
var simpleReactValidator = require("simple-react-validator");

export default class extends React.Component {
  /*all event and state*/
  constructor(props) {
    super(props);
    this.validator = new simpleReactValidator();
    this.state = {
      data: [],
      stateList: [],
      drpStateValue: "",
      newData: "",
      stateId: "",
      modal: false,
      newQus: true,
      alertMessageText: "",
      alertMessageVisible: false,
      alertMessageColor: "",
      loading: false,
      btnAddloading: false,
      btnEditloading: false,
      updateModel: false,
      qus_id: "",
      question_text: "",
      question_info: "",
      editQusData: "",
      errorEmail: false,
      qusForm: true,
      btnName: "Add",
      loaderStatus: true,
      setQusFocus: false,
      setInfoFocus: false,
    };

    this.drpClickState = this.drpClickState.bind(this);

    this.btnLoadQuestion = this.btnLoadQuestion.bind(this);

    this.changeTxtAddQues = this.changeTxtAddQues.bind(this);

    this.changeTxtAddQusInfo = this.changeTxtAddQusInfo.bind(this);

    this.clickBtnAddQus = this.clickBtnAddQus.bind(this);

    this.onDismiss = this.onDismiss.bind(this);

    this.toggle = this.toggle.bind(this);

    this.btnAddloading = this.btnAddloading.bind(this);

    this.btnEditloading = this.btnEditloading.bind(this);

    this.updateModal = this.updateModal.bind(this);

    this.toogleModelClose = this.toogleModelClose.bind(this);

    this.AddtoogleModelClose = this.AddtoogleModelClose.bind(this);
  }

  componentDidMount() {
    var that = this;

    getRequest({ url: "/api/get_all_statelist" })
      .then(function (state_response) {
        that.setState({
          stateList: state_response.data.result,
        });
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.status === 403) {
            browserHistory.push("/");
            window.location.reload();
          } else {
            console.log(error);
          }
        } else {
          console.log(error);
        }
      });
  }
  toggle() {
    this.setState({
      loading: !this.state.loading,
      progress: 0.5,
    });
  }
  btnAddloading() {
    this.setState({
      btnAddloading: !this.state.btnAddloading,
      progress: 0.5,
    });
  }

  btnEditloading() {
    this.setState({
      btnEditloading: !this.state.btnEditloading,
      progress: 0.5,
    });
  }
  toogleModelClose() {
    this.setState({
      qusForm: true,
    });
  }
  AddtoogleModelClose(e) {
    var get_value = e.target.value;
    //console.log();
    if (get_value === "btnadd")
      this.setState({
        qus_id: "",
        qusForm: false,
        question_text: "",
        question_info: "",
        btnName: "Add",
        alertMessageVisible: false,
      });
  }

  toggleModal = (e) => {
    var that = this;

    // that.setState({
    //     qus_id: "", qusForm: !that.state.qusForm,question_text:"",question_info:"", btnName:"Add"
    // });
    var qus_id = e.target.value;
    if (qus_id !== "") {
      that.setState({ qus_id: qus_id, btnName: "Update", qusForm: false, setQusFocus: true });

      getRequest({ url: "/api/get_audit_question_by_id/" + qus_id })
        .then(function (response) {
          //console.log(response.data.result[0]['id']);
          that.setState({
            question_text: response.data.result[0]["question_text"],
            question_info: response.data.result[0]["question_info"],
            alertMessageVisible: false,
          });
        })
        .catch(function (error) {
          //console.log(response);
          if (error.response) {
            if (error.response.status === 403) {
              browserHistory.push("/");
              window.location.reload();
            } else {
              console.log(error);
            }
          } else {
            console.log(error);
          }
        });
    }
  };
  updateModal = (e) => {
    this.setState({
      updateModel: !this.state.updateModel,
    });
  };
  updateToggleModal = (e) => {
    var that = this;
    var qus_id = e.target.value;
    if (qus_id !== "") {
      that.setState({
        qus_id: qus_id,
      });

      getRequest({ url: "/api/get_audit_question_by_id/" + qus_id })
        .then(function (response) {
          //console.log(response.data.result[0]['id']);
          that.setState({
            question_text: response.data.result[0]["question_text"],
            question_info: response.data.result[0]["question_info"],
            updateModel: !that.state.updateModel,
            alertMessageVisible: false,
          });
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status === 403) {
              browserHistory.push("/");
              window.location.reload();
            } else {
              console.log(error);
            }
          } else {
            console.log(error);
          }
        });
    } else {
    }
  };
  btnLoadQuestion(e) {
    var that = this;

    var state_id = this.state.drpStateValue;
    if (state_id !== "") {
      that.setState({
        loading: !this.state.loading,
        progress: 0.5,
        stateId: state_id,
        loaderStatus: false,
      });
      getRequest({ url: "/api/get_audit_question_by_state/" + state_id })
        .then(function (response) {
          that.setState({
            data: Array.isArray(response.data.result) ? response.data.result : [],
            newQus: false,
            loading: false,
            loaderStatus: true,
            alertMessageVisible: false,
          });
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status === 403) {
              browserHistory.push("/");
              window.location.reload();
            } else {
              console.log(error);
            }
          } else {
            console.log(error);
          }
        });
    } else {
      if (that.validator.allValid()) {
      } else {
        that.validator.showMessages();
        // rerender to show messages for the first time
        that.forceUpdate();
      }
      that.setState({
        newQus: true,
        alertMessageVisible: false,
        data: [],
        errorEmail: true,
      });
    }
  }
  drpClickState = (e) => {
    this.setState({
      drpStateValue: e.target.value,
    });
    var state_id = e.target.value;
    if (state_id === "") {
      this.setState({
        newQus: true,
        alertMessageVisible: false,
        data: [],
      });
    }
  };

  changeTxtAddQues = (e) => {
    //this.refs.textInput.focus();
    this.setState({
      question_text: e.target.value,
      setQusFocus: true,
      setInfoFocus: false,
    });

    // this.refs.linkInput.focus();
    // this.setState({
    //     question_text: e.target.value
    // });
  };
  changeTxtAddQusInfo = (e) => {
    this.setState({
      question_info: e.target.value,
      setInfoFocus: true,
      setQusFocus: false,
    });
  };

  clickBtnAddQus = (e) => {
    var that = this;
    if (that.validator.allValid()) {
    } else {
      that.validator.showMessages();
      // rerender to show messages for the first time
      that.forceUpdate();
    }
    var qus_id = that.state.qus_id;
    //clickBtnAddQus
    if (qus_id === "") {
      // add question
      var state_id = that.state.stateId;
      //console.log(state_id);
      var question_text = that.state.question_text;
      //console.log(question_text);
      var question_info = that.state.question_info;
      //console.log(question_info);
      if (state_id !== "" && question_text !== "" && question_info !== "") {
        that.setState({
          btnAddloading: !that.state.btnAddloading,
          progress: 0.5,
        });

        postRequest({
          url: "/api/add_question",
          payload: {
            state_id: state_id,
            question_text: question_text,
            question_info: question_info,
          },
        })
          .then(function (qus_response) {
            //console.log(qus_response.data.message);
            if (qus_response.data.success) {
              that.refreshQuestion();
              that.setState({
                alertMessageVisible: true,
                alertMessageColor: "success",
                alertMessageText: qus_response.data.message,
                qusForm: true,
              });
            } else {
              that.setState({
                alertMessageVisible: true,
                alertMessageColor: "danger",
                alertMessageText: qus_response.data.message,
              });
            }
            that.setState({
              modal: false,
              btnAddloading: false,
              qusForm: true,
            });
          })
          .catch(function (error) {
            if (error.response) {
              if (error.response.status === 403) {
                browserHistory.push("/");
                window.location.reload();
              } else {
                console.log(error);
              }
            } else {
              console.log(error);
            }
          });
      } else {
        that.setState({
          modal: true,
          errorEmail: true,
        });
      }
    } // update question
    else {
      //var state_id_up = that.state.stateId;
      var question_text1 = that.state.question_text;
      //console.log(question_text);
      var question_info1 = that.state.question_info;
      //console.log(question_info);
      if (question_text1 !== "" && question_info1 !== "") {
        that.setState({
          btnAddloading: !that.state.btnAddloading,
          progress: 0.5,
        });

        postRequest({
          url: "/api/edit_question",
          payload: {
            id: qus_id,
            question_text: question_text1,
            question_info: question_info1,
          },
        })
          .then(function (qus_response) {
            //console.log(qus_response.data.message);
            if (qus_response.data.success) {
              that.refreshQuestion();
              // axios
              // .get('/api/get_audit_question_by_state/' + state_id_up)
              // .then(function (refreshresponse) {
              //     console.log(refreshresponse.data.result);
              //     that.setState({
              //         data: refreshresponse.data.result
              //     });
              // })
              // .catch(function (error) {
              //     console.log(error);
              // });
              that.setState({
                alertMessageVisible: true,
                alertMessageColor: "success",
                alertMessageText: qus_response.data.message,
                qusForm: true,
              });
            } else {
              that.setState({
                alertMessageVisible: true,
                alertMessageColor: "danger",
                alertMessageText: qus_response.data.message,
              });
            }
            that.setState({
              btnAddloading: false,
              qusForm: true,
            });
          })
          .catch(function (error) {
            if (error.response) {
              if (error.response.status === 403) {
                browserHistory.push("/");
                window.location.reload();
              } else {
                console.log(error);
              }
            } else {
              console.log(error);
            }
          });
      } else {
      }
    }
  };
  refreshQuestion() {
    var that = this;
    var state_id = that.state.stateId;
    if (state_id !== "") {
      getRequest({ url: "/api/get_audit_question_by_state/" + state_id })
        .then(function (refreshresponse) {
          ///console.log(refreshresponse.data.result);
          that.setState({
            data: refreshresponse.data.result,
          });
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status === 403) {
              browserHistory.push("/");
              window.location.reload();
            } else {
              console.log(error);
            }
          } else {
            console.log(error);
          }
        });
    }
  }

  onDismiss() {
    var that = this;
    that.setState({
      alertMessageVisible: false,
    });
  }
  /*all event and state*/

  render() {
    // const ViewContent = ({ children }) => <div className="view-content view-components">{children} </div>;

    const ViewHeader = () => (
      <div className="page-header">
        <h1 className="title">Questions</h1>
        <p className="subtitle">Manage audit related questions here</p>
      </div>
    );

    const StateDropDownList = () => (
      <div>
        <h6 className="mb-4 text-uppercase">Select State</h6>
        <div className="row align-items-end">
          <div className="col-md-8">
            <FormGroup>
              <StateListClass stateValue={this.state.drpStateValue} drpChangeState={this.drpClickState} stateFillData={this.state.stateList} />
              <span className="error-text">{this.validator.message("State", this.state.drpStateValue, "required")}</span>
            </FormGroup>
          </div>
          <div className="col-md-4 btnmarginTop">
            <LaddaButton
              className={this.state.errorEmail === "true" ? "input-border-red" : "btn btn-warning load-btn"}
              loading={this.state.loading}
              onClick={this.btnLoadQuestion}
              data-color="#eee"
              data-size={S}
              data-style={EXPAND_RIGHT}
              data-spinner-size={30}
              data-spinner-color="#ddd"
              data-spinner-lines={12}
            >
              Load Question{" "}
            </LaddaButton>
          </div>
        </div>
      </div>
    );

    const AlertMessage = () => (
      <AlertMessageClass
        alertMessageColor={this.state.alertMessageColor}
        alertMessageVisible={this.state.alertMessageVisible}
        onDismiss={this.onDismiss}
        alertMessageText={this.state.alertMessageText}
      />
    );

    const QuestionTable = () => <QuestionTableClass stateFillData={this.state.data} toggleModal={this.toggleModal} />;

    return (
      <div className="view">
        <ViewHeader />

        <div className="view-content view-components">
          <Card className="mb-4">
            <CardBlock className="table-responsive">
              <StateDropDownList />
            </CardBlock>
          </Card>
          <br />

          <Card className="mb-4" hidden={this.state.qusForm}>
            <div className="row">
              <CardBlock className="table-responsive">
                <h6 className="mb-4 text-uppercase offset-md-3"> {this.state.btnName} Audit Questions</h6>

                <div className="row">
                  <div className="col-md-12">
                    <div className="col-md-6 offset-md-3">
                      <FormGroup>
                        <Label>Question Text</Label>
                        <Input
                          type="textarea"
                          name="quesText"
                          value={this.state.question_text}
                          id="quesText"
                          className="form-control-danger form-control"
                          onChange={this.changeTxtAddQues}
                          placeholder="Question Text"
                          autoFocus={this.state.setQusFocus}
                          onBlur={this.removeFocus}
                          maxLength="480"
                        />
                        <span className="error-text">{this.validator.message("question text", this.state.question_text, "required")}</span>
                      </FormGroup>
                    </div>

                    <div className="col-md-6 offset-md-3">
                      <FormGroup>
                        <Label>Question Help Text</Label>
                        <Input
                          type="textarea"
                          value={this.state.question_info}
                          name="qusInfo"
                          id="qusInfo"
                          onChange={this.changeTxtAddQusInfo}
                          placeholder="Question help text"
                          autoFocus={this.state.setInfoFocus}
                          onBlur={this.removeFocus}
                          maxLength="480"
                        />

                        <span className="error-text">{this.validator.message("question help text", this.state.question_text, "required")}</span>
                      </FormGroup>
                    </div>
                    <div className="col-md-9 offset-md-3">
                      <LaddaButton
                        className="btn btn-primary"
                        onClick={this.clickBtnAddQus}
                        loading={this.state.btnAddloading}
                        data-color="#eee"
                        data-size={S}
                        data-style={EXPAND_RIGHT}
                        data-spinner-size={30}
                        data-spinner-color="#ddd"
                        data-spinner-lines={12}
                      >
                        {" "}
                        {this.state.btnName}{" "}
                      </LaddaButton>
                      &nbsp;
                      <Button color="secondary" onClick={this.toogleModelClose}>
                        {" "}
                        Cancel{" "}
                      </Button>
                    </div>
                  </div>
                </div>
              </CardBlock>
            </div>
          </Card>

          <Card className="mb-4">
            <CardBlock className="table-responsive">
              <AlertMessage />{" "}
              {/* <Alert color="success">
                                                                            This is a success alert — check it out!
                                                                        </Alert> */}
              <h6 className="mb-4 text-uppercase">
                {" "}
                Manage Audit Questions
                <span className="pull-right">
                  <button className="btn btn-sm btn-warning pointerClass" value="btnadd" hidden={this.state.newQus} onClick={this.AddtoogleModelClose}>
                    <i className="fa fa-plus lg"></i> &nbsp; Add New Question{" "}
                  </button>
                </span>
              </h6>
              <QuestionTable />
              <LoaderClass visibleStatus={this.state.loaderStatus} />
            </CardBlock>
          </Card>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/questions/index.js